import { useThemeContext } from './ThemeProvider';
export default function useTheme() {
  return useThemeContext();
}
